export default __webpack_public_path__ + "static/media/TEMPLATE-PROMOCAO.786a116a.png";